import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
    Lookup
} from 'devextreme-react/data-grid';
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarSituacaoDividaDs } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class SituacaoDividaBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
        this.situacaoDivida = [
            { id: "1", descricao: "Exigível" },
            { id: "2", descricao: "Suspenso" },
            { id: "3", descricao: "Extinto" },
        ];
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Situação de Dívida">
                    <DataGrid
                        dataSource={criarSituacaoDividaDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={'sequencial'} caption={"#"} width={'150'} allowEditing={false} />
                        <Column dataField={'nome'} caption={"Nome"} />
                        <Column dataField={'situacaoDeCredito'} caption={"Situação do Crédito"}>
                            <Lookup
                                dataSource={this.situacaoDivida}
                                valueExpr={"id"}
                                displayExpr={"descricao"} />
                        </Column>
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}
